import React from 'react';

const CryptoPayMethod = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="24" fill="currentColor" />
      <g clipPath="url(#clip0_22_402)">
        <rect x="9" y="9" width="30" height="30" rx="15" fill="var(--card)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 9C15.7155 9 9 15.7155 9 24C9 32.2845 15.7155 39 24 39C32.2845 39 39 32.2845 39 24C39 15.7155 32.2845 9 24 9ZM24 10.5C24 14.0804 22.5777 17.5142 20.0459 20.0459C17.5142 22.5777 14.0804 24 10.5 24C14.0804 24 17.5142 25.4223 20.0459 27.9541C22.5777 30.4858 24 33.9196 24 37.5C24 33.9196 25.4223 30.4858 27.9541 27.9541C30.4858 25.4223 33.9196 24 37.5 24C33.9196 24 30.4858 22.5777 27.9541 20.0459C25.4223 17.5142 24 14.0804 24 10.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_402">
          <rect x="9" y="9" width="30" height="30" rx="15" fill="var(--card)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CryptoPayMethod;
